import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onRouteUpdate = () => {
  if (typeof document !== "undefined") {
    const fadeInElements = document.querySelectorAll(
      ".fadeInUp, .fadeInRight, .fadeInLeft"
    )

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on")
          }
        })
      },
      { threshold: 0.1 }
    )

    fadeInElements.forEach(el => observer.observe(el))

    return () => {
      fadeInElements.forEach(el => observer.unobserve(el))
    }
  }
}
